import './ActionPanel.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import Loader from '../DAcApplication/components/loader';
const ActionPanel = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} `
  }, /*#__PURE__*/React.createElement("div", {
    className: "action-panel__module-group"
  }, /*#__PURE__*/React.createElement("button", {
    className: `${props.inactive ? 'disabled' : ''} action-panel__btn btn btn-primary`,
    onClick: props.onSubmit
    // disabled={props.isLoading || props.inactive}
  }, /*#__PURE__*/React.createElement("span", {
    className: `action-panel__btn-title ${props.isLoading ? 'action-panel__btn-title--loading' : ''}`
  }, props.submitText), props.isLoading && /*#__PURE__*/React.createElement(Loader, null))));
};
export default ActionPanel;
const commonStyles = "cym1yo8";
const rtlStyles = "r101o0h";
const ltrStyles = "l1fq2e9j";